import React from "react";
import { useFormik } from "formik";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import ScheduleService from "../../../services/KangarooServices/ScheduleService";
import toast from "react-hot-toast";

const DAYS = [
  { value: 0, label: "Sunday" },
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
];

const formatTime = (value) => {
  if (!value) return null;

  // If Flatpickr Date
  if (value instanceof Date) {
    const hours = String(value.getHours()).padStart(2, "0");
    const minutes = String(value.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  // If already a time string "HH:mm"
  if (typeof value === "string") {
    return value;
  }

  // If API sends { ticks: number }
  if (typeof value === "object" && value.ticks !== undefined) {
    const date = new Date(value.ticks);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  return null;
};

const ScheduleBreakForm = ({ isOpen, toggle, selectedItem, fetchdata }) => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      dayOfWeek: selectedItem?.dayOfWeek ?? 0,
      breakStart: selectedItem?.breakStart || null,
      breakEnd: selectedItem?.breakEnd || null,
    },
    onSubmit: async (values) => {
      const payload = {
        dayOfWeek: values.dayOfWeek,
        breakStart: formatTime(values.breakStart),
        breakEnd: formatTime(values.breakEnd),
      };

      try {
        let response;
        if (selectedItem?.id) {
          await ScheduleService.update(selectedItem?.id, payload);
          toast.success(response);
        } else {
          await ScheduleService.create(payload);
          toast.success("Created successfull.");
        }

        fetchdata();
        toggle();
      } catch (error) {
        console.log(error);
        toast.error(error);
      }
    },
  });

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Schedule Break Form</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          {/* Day Select */}
          <div className="mb-3">
            <label className="form-label">Day</label>
            <select
              name="dayOfWeek"
              className="form-select"
              value={formik.values.dayOfWeek}
              onChange={(e) =>
                formik.setFieldValue("dayOfWeek", Number(e.target.value))
              }
            >
              {DAYS.map((day) => (
                <option key={day.value} value={day.value}>
                  {day.label}
                </option>
              ))}
            </select>
          </div>

          {/* Break Start */}
          <div className="mb-3">
            <label className="form-label">Break Start</label>
            <Flatpickr
              className="form-control"
              options={{
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
              }}
              value={formik.values.breakStart}
              onChange={(date) => formik.setFieldValue("breakStart", date[0])}
            />
          </div>

          {/* Break End */}
          <div className="mb-3">
            <label className="form-label">Break End</label>
            <Flatpickr
              className="form-control"
              options={{
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
              }}
              value={formik.values.breakEnd}
              onChange={(date) => formik.setFieldValue("breakEnd", date[0])}
            />
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={toggle}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              {selectedItem?.id ? "Update" : "Create"}
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default ScheduleBreakForm;
